export default __webpack_public_path__ + "static/media/icon-table-extrato.79f6285a.svg";